import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { createPcmpCategory, pcmpProjectQueryKeys } from '../api/pcmpProjects.api';
import type { PcmpCatalogItem, PcmpProjectOptions } from '../types/pcmpProject.types';

export function useCreatePcmpCategory(onSuccess: (category: PcmpCatalogItem) => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (name: string) => createPcmpCategory(name),
    onSuccess: (category) => {
      // Offer it in the form right away, without waiting for a refetch.
      queryClient.setQueryData<PcmpProjectOptions>(pcmpProjectQueryKeys.options(), (options) =>
        options ? { ...options, categories: [...options.categories, category] } : options,
      );
      void queryClient.invalidateQueries({ queryKey: pcmpProjectQueryKeys.options() });
      toast.success(`Category "${category.name}" added`);
      onSuccess(category);
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to add the category');
    },
  });
}
